Ext.ns('mx.app.widget');

mx.app.widget.WindowRecordForm = Ext.extend(mx.app.widget.WindowForm, {
    titleDisplayField: 'name',
    titleFormat: null,
    addAction: false,
    onUpdateCallback: null,
    initComponent: function() {
        mx.app.widget.WindowRecordForm.superclass.initComponent.apply(this, arguments);

        if (!this.record) {
            this.record = new this.recordClass({});
        }
        if (this.recordClass) {
            this.reader = new mx.data.JsonReader(
                {
                    totalProperty: 'total',
                    successProperty: 'success',
                    root: 'rows',
                },
                this.recordClass
            );
        }

        this.form.on(
            'afterLayout',
            function() {
                if (this.store && !this.recordClass) {
                    this.store.proxy.load(
                        null,
                        this.store.reader,
                        function(obj, options, success) {
                            if (success) {
                                if (this.record) {
                                    this.record.data = obj.records[0].data;
                                }
                                this.form.getForm().loadRecord(obj.records[0]);

                                if (this.form.onRecordLoaded) {
                                    this.form.onRecordLoaded.call(this.form, obj.records[0]);
                                }
                            }
                        },
                        this,
                        null,
                        {method: 'GET', url: mx.PATH + this.store.url + this.record.get('id')}
                    );
                } else if (this.objectId) {
                    mx.data.Ajax.request({
                        url: mx.PATH + this.url + this.objectId,
                        method: 'GET',
                        success: function(response) {
                            var o = this.reader.read(response);
                            if (o.success) {
                                this.form.getForm().loadRecord((this.formrecord = o.records[0]));
                                if (this.titleFormat) {
                                    this.setTitle(
                                        String.format(this.titleFormat, this.formrecord.get(this.titleDisplayField))
                                    );
                                }

                                if (this.form.onRecordLoaded) {
                                    this.form.onRecordLoaded.call(this.form, this.formrecord);
                                }
                            } else {
                                //todo AK: process o.errors
                            }
                        },
                        scope: this,
                    });
                }
            },
            this,
            {single: true}
        );

        if (this.editable) {
            this.okButton.handler = function(btn, e) {
                if (this.form.getForm().isValid()) {
                    var onUpdate = function() {
                        this.el.mask();
                        if (this.form.preUpdate) {
                            this.form.preUpdate();
                        }
                        if (this.store && !this.recordClass) {
                            var fn = function(ds, record, operation) {
                                if (operation == Ext.data.Record.COMMIT) {
                                    this.store.un('update', fn, this);
                                    this.destroy();
                                }
                            };
                            this.record.maskedElement = this.el;
                            this.store.on('update', fn, this);
                            this.record.dirty = true;
                            this.form.getForm().updateRecord(this.record);
                        } else {
                            this.record.dirty = true;
                            this.form.getForm().updateRecord(this.record);
                            Ext.Ajax.request({
                                url: mx.PATH + (this.store ? this.store.url : this.url),
                                success: function(response) {
                                    var o = this.reader.read(response);
                                    if (o.success) {
                                        this.el.unmask();
                                        //                                        this.record.data['id'] = o.records[0].get('id'); //do NOT change to record.set('id', ...)
                                        //                                        this.record.commit();
                                        o.records[0].id = this.record.id;
                                        if (this.store) {
                                            this.store.add(o.records[0]);
                                        }
                                        this.fireEvent('success', o.records[0]);
                                        this.destroy();
                                    } else {
                                        this.record.reject();
                                        this.el.unmask();
                                        var errors = o.errors;
                                        if (!Ext.isArray(errors)) {
                                            errors = [errors];
                                        }
                                        Ext.Msg.show({
                                            title: 'Error',
                                            msg: errors
                                                .map(function(error) {
                                                    return error.message;
                                                })
                                                .join('<br />'),
                                            icon: Ext.Msg.ERROR,
                                            buttons: Ext.Msg.OK,
                                        });
                                    }
                                },
                                failure: function(response) {
                                    this.record.reject();
                                    this.el.unmask();
                                    this.fireEvent('failure', this.record);
                                    Ext.Msg.show({
                                        title: 'Error ' + (response.status > 0 ? response.status : ''),
                                        msg: response.statusText, //response.responseText - full response from server
                                        icon: Ext.Msg.ERROR,
                                        buttons: Ext.Msg.OK,
                                    });
                                },
                                scope: this,
                                jsonData: this.record.getData(),
                            });
                        }
                        if (!!this.onUpdateCallback) {
                            this.onUpdateCallback();
                        }
                    };
                    if (this.form.getAlerts && this.form.getAlerts()) {
                        Ext.Msg.confirm(
                            'Confirmation',
                            this.form.getAlerts(),
                            function(btn, text) {
                                if (btn == 'yes') {
                                    onUpdate.call(this);
                                }
                            }.createDelegate(this)
                        );
                    } else {
                        onUpdate.call(this);
                    }
                } else {
                    Ext.Msg.show({
                        title: 'Warning',
                        msg: 'Some fields are not filled out correctly',
                        icon: Ext.Msg.WARNING,
                        buttons: Ext.Msg.OK,
                    });
                }
            };
        }
    },
});
